import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ contactInfo }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const menuItems = [
    { label: 'About', id: 'about' },
    { label: 'Expertise', id: 'expertise' },
    { label: 'Achievements', id: 'achievements' },
    { label: 'Hospital', id: 'hospital' },
    { label: 'Conditions', id: 'conditions' },
    { label: 'Insights', id: 'clinical-insights' },
    { label: 'Videos', id: 'education-videos' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo/Name */}
          <button
            onClick={() => scrollToSection('hero')}
            className="text-xl font-bold text-slate-800 hover:text-teal-700 transition-colors"
          >
            Dr. Veerendra C Patil
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="px-4 py-2 text-sm font-medium text-slate-700 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-all"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Contact Info - Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href={`tel:${contactInfo?.phone}`}
              className="flex items-center space-x-2 text-sm text-slate-600 hover:text-teal-700 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span>{contactInfo?.phone}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-slate-700 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-slate-200 py-4 space-y-2 animate-in slide-in-from-top-5 duration-200">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left px-4 py-2 text-sm font-medium text-slate-700 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-colors"
              >
                {item.label}
              </button>
            ))}
            <div className="pt-4 border-t border-slate-200 space-y-2">
              <a
                href={`tel:${contactInfo?.phone}`}
                className="flex items-center space-x-2 px-4 py-2 text-sm text-slate-600 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span>{contactInfo?.phone}</span>
              </a>
              <a
                href={`mailto:${contactInfo?.email}`}
                className="flex items-center space-x-2 px-4 py-2 text-sm text-slate-600 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>{contactInfo?.email}</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;